/* UI-only progressive enhancement. No product URL rewriting, fetching, cart mutations or tracking. */
(() => {
  if (customElements.get('bijc-edit-tabs')) return;
  class BijcEditTabs extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._buttons = Array.from(this.querySelectorAll('[data-be-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-be-panel]'));
      if (!this._buttons.length || !this._panels.length) return;
      this._bound = true;
      const tablist = this.querySelector('[data-be-tablist]');
      if (tablist) tablist.setAttribute('role', 'tablist');
      this._buttons.forEach((button, index) => {
        const panel = this._panels.find(item => item.id === button.dataset.beTab);
        if (!panel) return;
        button.id = button.dataset.beTab + '-tab';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        button.addEventListener('click', () => this.select(index, false));
        button.addEventListener('keydown', event => {
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this._buttons.length;
          if (event.key === 'ArrowLeft') next = (index + this._buttons.length - 1) % this._buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this._buttons.length - 1;
          this.select(next, true);
        });
      });
      this.classList.add('be-tabs--ready');
      this.select(0, false);
    }
    select(index, focus) {
      const active = this._buttons[index];
      if (!active) return;
      this._buttons.forEach(button => {
        const selected = button === active;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        button.classList.toggle('is-active', selected);
      });
      this._panels.forEach(panel => { panel.hidden = panel.id !== active.dataset.beTab; });
      if (focus) active.focus();
    }
  }
  customElements.define('bijc-edit-tabs', BijcEditTabs);
})();
